<template>
	<div class="assoc-file" @click="$emit('click')" :title="association.name">
		<div class="assoc-file__thumb">
			<img
				v-if="thumbSrc"
				:src="thumbSrc"
				:alt="association.name"
				class="assoc-file__img"
			/>
			<v-icon v-else size="22" :color="iconColor">{{ icon }}</v-icon>

			<v-icon
				class="assoc-file__close"
				size="13"
				@click.stop="$emit('remove')"
			>mdi-close</v-icon>
		</div>
		<span class="assoc-file__name text-truncate">{{ association.name }}</span>
	</div>
</template>

<script>
export default {
	name: 'AssociationFileCard',
	props: {
		association: {
			type: Object,
			required: true
		}
	},
	computed: {
		thumbSrc() {
			return this.association.pathmedia && this.association.ext && this.isImageExt(this.association.ext)
				? this.association.pathmedia.path
				: null
		},
		icon() {
			const e = (this.association.ext || '').toLowerCase()
			if (e === 'pdf') return 'mdi-file-pdf-box'
			if (['doc', 'docx'].includes(e)) return 'mdi-file-word-box'
			if (['xls', 'xlsx'].includes(e)) return 'mdi-file-excel-box'
			if (['ppt', 'pptx'].includes(e)) return 'mdi-file-powerpoint-box'
			if (this.isImageExt(e)) return 'mdi-file-image-box'
			if (['zip', 'rar', '7z'].includes(e)) return 'mdi-folder-zip-outline'
			if (['dwg', 'dxf', 'rvt', 'ifc', 'nwd'].includes(e)) return 'mdi-cube-outline'
			return 'mdi-file-outline'
		},
		iconColor() {
			return this.association.pathmedia ? '#5e85ef' : '#8b94ad'
		}
	},
	methods: {
		isImageExt(ext) {
			return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes((ext || '').toLowerCase())
		}
	}
}
</script>

<style scoped>
.assoc-file {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 60px;
	cursor: pointer;
	flex-shrink: 0;
}

.assoc-file__thumb {
	position: relative;
	width: 52px;
	height: 52px;
	border-radius: 10px;
	border: 1.5px solid #c5d3f8;
	background: #f0f4ff;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
}

.assoc-file:hover .assoc-file__thumb {
	background: #e0e9ff;
	border-color: #5e85ef;
	box-shadow: 0 2px 6px rgba(94, 133, 239, 0.18);
}

.assoc-file__img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.assoc-file__close {
	position: absolute;
	top: 2px;
	right: 2px;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	background: rgba(24, 36, 61, 0.55);
	color: #fff !important;
	opacity: 0;
	transition: opacity 0.15s;
}

.assoc-file:hover .assoc-file__close {
	opacity: 1;
}

.assoc-file__name {
	margin-top: 4px;
	font-size: 10px;
	color: #576080;
	max-width: 60px;
	text-align: center;
}
</style>